module.exports = __webpack_public_path__ + "img/check-circle.3b3fe3e1.svg";